import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { path } from 'ramda';
import Breadcrumbs from '../../common/Breadcrumbs';
import Table from '../../сomponents/Table';
import ConfirmAction from '../../common/ConfirmAction';
import { changeModalState } from '../../actions/modal'
import { deleteObject } from '../../actions/objectToDelete';
import { fetchAllQuotes, deleteQuoteById } from '../../api/quotes';
import './style.css';
import Preloader from "../../common/Preloader";
import hasAccess from "../../helpers/permissionChecker";
import StatusContainer from "./StatusContainer";

export class Quotes extends Component {

  constructor(props) {
    super(props);
    this.onSearch = this.onSearch.bind(this);
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this);
    this.handlerDelete = this.handlerDelete.bind(this);
    this.handlerEdit = this.handlerEdit.bind(this);
    this.handlerUpload = this.handlerUpload.bind(this);
    this.handlerEmail = this.handlerEmail.bind(this);
    this.handlerWO = this.handlerWO.bind(this);
    this.addQuote = this.addQuote.bind(this);
    this.onChangeCurrentPage = this.onChangeCurrentPage.bind(this);


    this.state = {
      items: Array.from([]),
      container: false,
      search: '',
      itemsPerPage: 10,
      loading: true,
      currentPage: 0,
    };

    this.columns = [
      'username',
      'name',
      'projectName',
      'description',
      'created',
      'status',
    ];

    this.columnNames = [
      'Author',
      'Name',
      'Customer',
      'Description',
      'Date Created',
      'Status',
    ];
  }

  addQuote() {
    this.props.moveToAdd();
  }

  onSearch(e) {
    e.preventDefault();
    this.setState({
      search: e.target.value,
    });
    return false;
  }

  onChangeItemsPerPage(e) {
    e.preventDefault();
    this.setState({
      itemsPerPage: e.target.value,
    });
    return false;
  }

  onChangeCurrentPage(currentPage) {
    this.setState({
      currentPage: currentPage,
    });
  }

  componentDidUpdate() {
    const itemsList = path(['quotes', 'list'], this.props);
    const { loading } = this.state;
    if (loading && itemsList) {
      this.setState({ loading: false });
    }
  }

  componentWillMount() {
    this.props.list();
  }

  handlerDelete(id) {
    this.props.handleObjectToDelete({
      id: parseInt(id),
      handler: deleteQuoteById,
    });

    this.props.handleModalState({
      isOpen: !this.props.modal.isOpen,
      modalId: 'deleteQuoteById',
    });
  }

  handlerWO(id) {
    this.props.moveToWOList(id);
  }

  handlerEdit(id) {
    this.props.moveToEdit(id);
  }

  handlerUpload() {
    this.props.moveToUpload();
  }

  handlerEmail() {
    this.props.moveToEmail();
  }

  render() {
    let itemsList = path(['quotes', 'list'], this.props);

    if (!itemsList || itemsList.length === 0) {
      itemsList = [];
    }

    const { loading } = this.state;

    const itemActions = {
      workOrders: {
        handler: this.handlerWO,
        permission: { 'permAreaKey': 'workOrder', 'permTypeKey': 'view' },
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-table icon-stack-1x'],
        iconClass: '',
        context: this,
        hasWrapper: true,
        title: 'work orders',
      },
      edit: {
        handler: this.handlerEdit,
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-pencil icon-stack-1x'],
        iconClass: '',
        context: this,
        hasWrapper: true,
        title: 'edit',
      },
      delete: {
        handler: this.handlerDelete,
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-times icon-stack-1x'],
        iconClass: '',
        authorColumnName: 'uid',
        permission: { 'permAreaKey': 'quote', 'permTypeKey': 'delete' },
        context: this,
        hasWrapper: true,
        title: 'delete',
      }
    };

    const mainPart = loading ? <Preloader show={true} type='circle'/> :
      <Table
        items={itemsList}
        columns={this.columns}
        columnNames={this.columnNames}
        itemsPerPage={this.state.itemsPerPage}
        search={this.state.search}
        actions={itemActions}
        onSearch={this.onSearch}
        onChangeItemsPerPage={this.onChangeItemsPerPage}
        currentPage={this.state.currentPage}
        onChangeCurrentPage={this.onChangeCurrentPage}
        rowContainers={{
          status: StatusContainer
        }}
      />;
    return (
      <div style={{ paddingBottom: '25px' }}>
        <Breadcrumbs list={[
          { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
          { icon: 'format_quote', name: 'Quotes' },
        ]}/>
        <div className="card rounded">
          <div className="card-header rounded-top">
            Quotes
          </div>
          <div className="card-block">
            {hasAccess({ 'permAreaKey': 'quote', 'permTypeKey': 'create' }) &&
            <div className="clearfix mb-3">
              <button className="btn btn-rounded btn-icon ui-btn pull-right" onClick={this.addQuote}>
                <i className="material-icons">add_circle_outline</i>
                <span className="color-default">Add</span>
              </button>
            </div>
            }
            {mainPart}
            <ConfirmAction id={'deleteQuoteById'}/>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    list: () => {
      fetchAllQuotes()(dispatch);
    },
    moveToEdit: (id) => {
      dispatch(push('/pages/quotes-edit/' + id));
    },
    moveToWOList: (id) => {
      dispatch(push('/pages/quotes-wo/' + id));
    },
    moveToUpload: () => {
      dispatch(push('/pages/quotes-upload'));
    },
    moveToEmail: () => {
      dispatch(push('/pages/quotes-email'));
    },
    moveToDelete: () => {
      dispatch(push('/pages/job-cards-delete'));
    },
    moveToAdd: () => {
      dispatch(push('/pages/quote'));
    },
    handleModalState: (data) => {
      dispatch(changeModalState(data));
    },
    handleObjectToDelete: (data) => {
      dispatch(deleteObject(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Quotes);



// WEBPACK FOOTER //
// ./src/containers/Quotes/index.js